





































import HealthProfessionFieldUtils, {
  HealthProfessionField,
} from '@/utils/HealthProfessionFieldUtils';
import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Object as () => Partial<HealthProfessionField>,
    },
    mode: {
      type: String as () => 'create' | 'edit',
      required: true,
    },
    'error-messages': {
      type: Object as () => { [key: string]: string[] },
      default: () => ({}),
    },
  },

  computed: {
    internal: {
      get(): Partial<HealthProfessionField> {
        return (
          this.value ||
          HealthProfessionFieldUtils.healthProfessionField.generateDefault()
        );
      },
      set(val: Partial<HealthProfessionField>) {
        this.$emit('input', val);
      },
    },
  },
});
